import { gql } from "graphql-tag";
import { responseField } from "../../../base.graphql";
import {paginationFields} from "../geographical-zone/geographical-zone.graphql";

export const faqFields = `
id
                uniqueId
                question
                answer
                createdAt
`;

export const GET_ALL_FAQS_QUERY = gql`
    query GetAllFaqs($filtering: FAQsFilteringInputObject) {
        getAllFaqs(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${faqFields}
            }
            page {
                ${paginationFields}
            }
        }
    }
`;

export const CREATE_FAQ_MUTATION = gql`
    mutation CreateFaqMutation($input: FAQsInputObject!) {
        createFaqMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${faqFields}
            }
        }
    }
`;

export const UPDATE_FAQ_MUTATION = gql`
    mutation UpdateFaqMutation($input: FAQsInputObject!) {
        updateFaqMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${faqFields}
            }
        }
    }
`;

export const DELETE_FAQ_MUTATION = gql`
    mutation DeleteFaqMutation($uniqueId: String!) {
        deleteFaqMutation(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
        }
    }
`;